import {FC, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useRecoilValue} from 'recoil';
import AssignServiceRequests from '../../../components/ServiceRequests/assign-service-requests';
import {getIsUserCustomer} from '../../../global/lib';
import {authState} from '../../../store/auth/atoms';

const AssignServiceRequestsPage: FC = () => {
  const navigate = useNavigate();
  const {user} = useRecoilValue(authState);
  const isCustomer = getIsUserCustomer(user);

  useEffect(() => {
    if (isCustomer) {
      navigate('/serviceRequests', {replace: true});
    }
  }, [isCustomer, navigate]);

  if (isCustomer) {
    return null;
  }

  return (
    <div style={{height: '100%'}}>
      <AssignServiceRequests />
    </div>
  );
};

export default AssignServiceRequestsPage;
